module.exports = __webpack_public_path__ + "static/media/website-security-management2.cb6fd0ef.png";